package org.moxultimate.topwithmox.wallpapercrud.module

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import org.koin.dsl.module
import org.moxultimate.topwithmox.wallpaper.api.WallpaperRepository
import org.moxultimate.topwithmox.wallpapercrud.api.WallpaperCRUDRepository
import org.moxultimate.topwithmox.wallpapercrud.main.WallpaperCRUDViewModel

/**
 * wallpaperCRUDModule
 * Koin module for the wallpaper CRUD feature.
 * Registers both the read repository (WallpaperRepository) and write repository
 * (WallpaperCRUDRepository), then injects both into the ViewModel factory.
 */
val wallpaperCRUDModule = module {

    single {
        HttpClient(Js) {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                })
            }
        }
    }

    single {
        WallpaperRepository(httpClient = get())
    }

    single {
        WallpaperCRUDRepository(httpClient = get())
    }

    factory {
        WallpaperCRUDViewModel(repository = get(), crudRepository = get())
    }
}
